import Cookies from 'js-cookie'

export const initCookies = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const utm_source = urlParams.get('utm_source');
    const utm_content = urlParams.get('utm_content')
    const utm_campaign = urlParams.get('utm_campaign')
    const utm_medium = urlParams.get('utm_medium')
    const affiliate_subid = urlParams.get('affiliate_subid')
    const affiliate_subid_2 = urlParams.get('affiliate_subid_2')
    const affiliate_subid_3 = urlParams.get('affiliate_subid_3')
    const affiliate_subid_4 = urlParams.get('affiliate_subid_4')
    const partner_id = urlParams.get('partner_id')

    if (utm_source) Cookies.set('utm_source', utm_source, { expires: 30 })
    if (utm_content) Cookies.set('utm_content', utm_content, { expires: 30 })
    if (utm_campaign) Cookies.set('utm_campaign', utm_campaign, { expires: 30 })
    if (utm_medium) Cookies.set('utm_medium', utm_medium, { expires: 30 })
    if (affiliate_subid) Cookies.set('affiliate_subid', affiliate_subid, { expires: 30 })
    if (affiliate_subid_2) Cookies.set('affiliate_subid_2', affiliate_subid_2, { expires: 30 })
    if (affiliate_subid_3) Cookies.set('affiliate_subid_3', affiliate_subid_3, { expires: 30 })
    if (affiliate_subid_4) Cookies.set('affiliate_subid_4', affiliate_subid_4, { expires: 30 })
    if (partner_id) Cookies.set('partner_id', partner_id, { expires: 30 })
}